export const enum sizeType {
  Small = 'small',
  Medium = 'medium',
  Large = 'large'
}
